import {
    Column,
    Entity,
    Index,
    JoinColumn,
    ManyToOne,
    OneToMany,
    OneToOne,
    PrimaryGeneratedColumn, VersionColumn,
} from "typeorm";

import {Delta} from "quill/core";
import {Project} from "./Project";

@Index("content_pkey", ["id"], { unique: true })
@Entity("content")
export class Content {
  @PrimaryGeneratedColumn({ type: "bigint", name: "id" })
  id!: number;

  @Column("jsonb", { name: "delta", nullable: true })
  delta: Delta | null;

  @Column({ type: "bigint", name: "project_id" })
  projectId: number;

  @OneToOne(
    (type) => Project
  )
  project: Project;
}
